module.exports = __webpack_public_path__ + "img/Paotang-small.fdb8edeb.png";